import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Skeleton, Row, Col, Timeline } from "antd";
import { getlog } from "../../../actions/userlogAction";
import moment from "moment";

const List = ({
  getlog,
  ID,
  action_type,
  start,
  end,
  reload,
  setreload,
  keyword,
  content_type,
}) => {
  const [data, setdata] = useState(null);
  const [loading, setloading] = useState(true);
  const pageno = useRef(1);
  const page_size = useRef(100);

  useEffect(() => {
    getlog(
      pageno.current,
      page_size.current,
      content_type,
      ID,
      action_type,
      start,
      end,
      keyword
    ).then((result) => {
      setdata(result);
      setloading(false);
    });
  }, [reload]);

  if (loading) {
    return <Skeleton active />;
  }

  const results = data && data.results ? data.results : [];

  return (
    <>
      <Timeline>
        {results.map((item, index) => {
          const action = item && item.action ? item.action : "";
          const event = action ? action.split(" ")[0] : "";
          const parts = action ? action.split(/\(|\)/) : [];

          return (
            <Timeline.Item
              key={index}
              color={
                item && item.action_type === "create"
                  ? "green"
                  : item && item.action_type === "update"
                  ? "orange"
                  : "red"
              }
            >
              <Row>
                <Col flex="20%">
                  <h5>
                    {event} by {item && item.created_by}
                  </h5>
                </Col>
                <Col flex="60%">{action}</Col>
                <Col flex="20%">
                  <h5>
                    {item && item.timestamp
                      ? moment(item.timestamp).format("YYYY-MM-DD hh:mm A")
                      : ""}
                  </h5>
                </Col>
              </Row>
            </Timeline.Item>
          );
        })}
      </Timeline>
    </>
  );
};

export default connect(null, {
  getlog,
})(List);
